import { sleep } from '@/utils/sleep'
import { CreatePlaylistInput } from './client'

class SpotifyApiMock {
  public async createPlaylistWithTracks (accessToken: string, input: CreatePlaylistInput): Promise<string> {
    await sleep(800)
    return '1PVRhKhgMtQ3nl2Qd1RHb8'
  }
}

export default new SpotifyApiMock()
